module.exports = __webpack_public_path__ + "img/p2.148dc193.png";